'use client';
import { _ as _slicedToArray } from './slicedToArray-aa291011.esm.js';
import { VERSION, VAL_APP_PATH, VAL_APP_ID } from '@valbuild/ui';
import Script from 'next/script';
import { useState, useEffect } from 'react';
import { u as useRemoteConfigSender } from './useRemoteConfigSender-02451801.esm.js';
import { jsx, jsxs, Fragment } from 'react/jsx-runtime';
import './unsupportedIterableToArray-5baabfdc.esm.js';
import './objectSpread2-c1340c1c.esm.js';
import '@valbuild/core';
import '@valbuild/shared/internal';

var ValApp = function ValApp(_ref) {
  var config = _ref.config;
  var route = "/api/val"; // TODO: make configurable
  var _useState = useState(),
    _useState2 = _slicedToArray(_useState, 2),
    inMessageMode = _useState2[0],
    setInMessageMode = _useState2[1];
  useRemoteConfigSender(config);
  useEffect(function () {
    if (location.search === "?message_onready=true") {
      setInMessageMode(true);
      var interval = setInterval(function () {
        window.parent.postMessage({
          type: "val-ready"
        }, "*");
      });
      return function () {
        clearInterval(interval);
      };
    } else {
      setInMessageMode(false);
    }
  }, []);
  if (inMessageMode === undefined) {
    return null;
  }
  if (inMessageMode === true) {
    return /*#__PURE__*/jsx("div", {
      children: "Val Studio is disabled: in message mode"
    });
  }
  return /*#__PURE__*/jsxs(Fragment, {
    children: [/*#__PURE__*/jsx(Script, {
      type: "module",
      src: "".concat(route, "/static").concat(VERSION ? "/".concat(VERSION) : "").concat(VAL_APP_PATH),
      crossOrigin: "anonymous"
    }), /*#__PURE__*/jsx("div", {
      id: VAL_APP_ID
    })]
  });
};

export { ValApp };
